export enum ChangeRequestCategory {
    A = 'A',
    B = 'B',
    C = 'C',
    CostSavings = 'CostSavings',
}

export const ChangeRequestCategoryLabels: Record<ChangeRequestCategory | string, string> = {
    A: 'Category A',
    B: 'Category B',
    C: 'Category C',
    CostSavings: 'Cost Savings',
};
